import React from 'react'
import RoomOutlined from '@material-ui/icons/RoomOutlined'

export default function RoomOutlinedIcon() {

    return (
        <RoomOutlined />
    )
}